export default function radio({ variables }) {
    return {
        MuiRadio: {
            styleOverrides: {
                root: {
                    padding: variables.spacing_02,
                    "& .MuiSvgIcon-root": {
                        fontSize: "16px",
                    },
                    color: variables.interactive,
                    "&.Mui-checked": {
                        color: variables.interactive_selected,
                    },
                    "&.Mui-disabled": {
                        color: variables.text_disabled,
                    },
                },
                sizeSmall: {
                    "& .MuiSvgIcon-root": {
                        fontSize: "14px",
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=radio.js.map